/**
 * 操作记录
 */
import app from './app.js';

export const ActionStack = function (canvas, mask, type) {
	this.type = type
	this._objects = []
	this._currentIndex = 0
	this.canvas = canvas
	this.ctx = canvas.getContext('2d')
	this.mask = mask
	this.ctxMask = mask.getContext('2d')
	this.undoBtn = ''
	this.redoBtn = ''
}

/**
 * 添加操作记录对象
 * @param object 	obj 	操作记录对象
 */
ActionStack.prototype.addObject = function(obj) {
	var length = this._objects.length
	if (this._currentIndex < length)
		this._objects = this._objects.slice(0, this._currentIndex)
	this._objects.push(obj)
	this._currentIndex++
	this.checkBtn()
}

/**
 * 获取操作记录对象
 * @return object 	
 */
ActionStack.prototype.getObjects = function() {
	return this._objects
}

/**
 * 清空操作记录
 */
ActionStack.prototype.clear = function() {
	this._objects = []
	this._currentIndex = 0
	this.renderAll()
}

/**
 * 获取当前操作撤销/操作步骤
 * @return int 
 */
ActionStack.prototype.getCurrentIndex = function() {
	return this._currentIndex
}

/**
 * 撤销操作
 */
ActionStack.prototype.undo = function() {

	if (app.model.model == 0 && app.model.lastModel == 5) {
		return false
	}

	if (this._currentIndex == 0) 
		return false

	this._currentIndex--
	if (this.type == 'crop') {
		if (this._objects[this._currentIndex-1]) {
			this._renderCrop(this._objects[this._currentIndex-1])
		} else {
			this._currentIndex = 1
		}
	} else {
		this.renderAll(this._objects.slice(0, this._currentIndex))
	}

	this.checkBtn()
}

/**
 * 恢复操作
 */
ActionStack.prototype.redo = function() {

	if (app.model.model == 0 && app.model.lastModel == 5) {
		return false
	}

	if (this._currentIndex >= this._objects.length) 
		this._currentIndex--
	this._currentIndex++
	try{
		if (this._objects[this._currentIndex-1].type == 'crop')
			this._renderCrop(this._objects[this._currentIndex-1])
		else
			this.renderAll(this._objects.slice(0, this._currentIndex))
		this.checkBtn()
	}catch(e){
		console.log(e);
	}
}

/**
 * 绑定撤销恢复按钮
 * @param  elementObject undo 撤销按钮dom对象
 * @param  elementObject redo 恢复按钮dom对象
 */
ActionStack.prototype.bindBtn = function(undo, redo) {
	this.undoBtn = undo
	this.redoBtn = redo
	let _this = this
	for(var i=0;i<undo.length;i++){
		this.undoBtn[i].onclick = function() {
			_this.undo()
		}
	}
	for(var i=0;i<redo.length;i++){
		this.redoBtn[i].onclick = function() {
			_this.redo()
		}
	}
}

/**
 * 检测撤销恢复按钮的状态
 */
ActionStack.prototype.checkBtn = function() {
	for(var i=0;i<this.redoBtn.length;i++){
		if (this._currentIndex >= this._objects.length) {
			this.redoBtn[i].classList.add('forbid')
		} else {
			this.redoBtn[i].classList.remove('forbid')
		}
	}
	for(var i=0;i<this.undoBtn.length;i++){
		if (this.type == 'crop') {
			if (this._currentIndex == 1) {
				this.undoBtn[i].classList.add('forbid')
			} else {
				this.undoBtn[i].classList.remove('forbid')
			}
		} else {
			if (this._currentIndex == 0) {
				this.undoBtn[i].classList.add('forbid')
			} else {
				this.undoBtn[i].classList.remove('forbid')
			}
		}
	}
}

/**
 * 裁剪的撤销返回
 * @param  object items 选择的渲染对象
 */
ActionStack.prototype._renderCrop = function(item) {
	app.crop.cropBox.style.width = item.width + 'px'
	app.crop.cropBox.style.height = item.height + 'px'
	app.crop.cropBox.style.top = item.top + 'px'
	app.crop.cropBox.style.left = item.left + 'px'
	app.model.updateCropCover()
}

/**
 * 渲染画布上所有的对象
 * @param  object items 选择的渲染对象
 */
ActionStack.prototype.renderAll = function(items='') {
	this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
	items = items ? items : this.getObjects().slice(0, this.getCurrentIndex())
	for(let item of items) {
		switch(item.type) {
			case 'line': this._renderLine(item) ;break;
			case 'lasso': this._renderLasso(item);break;
			case 'polygon': this._renderPolygon(item);break;
		}
	}
}

/**
 * 渲染mask画布
 * @param  object items 选择的渲染对象
 */
ActionStack.prototype.renderTarget = function(items='') {
	this.ctxMask.save()
	this.ctxMask.clearRect(0, 0, this.mask.width, this.mask.height)
	this.ctxMask.fillRect(0, 0, this.mask.width, this.mask.height)
	this.ctxMask.restore()

	items = items ? items : this.getObjects().slice(0, this.getCurrentIndex())
	for(let item of items) {
		switch(item.type) {
			case 'line': this._renderTargetLine(item) ;break;
			case 'lasso': this._renderTargetLasso(item);break;
			case 'polygon': this._renderTargetPolygon(item);break;
		}
	}
}

/**
 * 根据保存的操作记录画线
 * @param  object obj 操作记录对象
 */
ActionStack.prototype._renderLine = function(obj) {
	let points = obj.points,
		ctx = this.ctx,
		ratio = obj.scale
	ctx.save()
	ctx.beginPath()
	ctx.lineCap = 'round';
	ctx.lineJoin = 'round';
	ctx.lineWidth = obj.lineWidth / ratio
	ctx.globalCompositeOperation = obj.globalCompositeOperation
	ctx.strokeStyle = obj.lineColor
	ctx.moveTo(points[0][0] / ratio, points[0][1] / ratio)
	for (var i = 0; i < points.length; i++) {
		ctx.lineTo(points[i][0] / ratio, points[i][1] / ratio)
	}
	ctx.stroke()
	ctx.restore()
}

/**
 * 根据保存的操作记录画套索
 * @param  object obj 操作记录对象
 */
ActionStack.prototype._renderLasso = function(obj) {
	let points = obj.points,
		ctx = this.ctx,
		ratio = obj.scale

	ctx.beginPath()
	ctx.save()
	ctx.lineCap = 'round';
	ctx.lineJoin = 'round';
	ctx.lineWidth = 2/ratio
    ctx.strokeStyle = 'rgba(255, 15, 3, 0.5)'
    ctx.fillStyle = 'rgba(255, 15, 3, 0.5)'
	ctx.globalCompositeOperation = obj.globalCompositeOperation
	ctx.moveTo(points[0][0] / ratio, points[0][1] / ratio)
	for (var i = 0; i < points.length; i++) {
		ctx.lineTo(points[i][0] / ratio, points[i][1] / ratio)
	}
	ctx.stroke()
	ctx.fill()
	ctx.restore()
}

/**
 * 根据保存的操作记录画多边形
 * @param  object obj 操作记录对象
 */
ActionStack.prototype._renderPolygon = function(obj) {
	let points = obj.points,
		ctx = this.ctx,
		ratio = obj.scale

	ctx.beginPath()
	ctx.save()
	ctx.lineCap = 'round';
	ctx.lineJoin = 'round';
	ctx.lineWidth = 2/ratio
    ctx.strokeStyle = 'rgba(255, 15, 3, 0.5)'
    ctx.fillStyle = 'rgba(255, 15, 3, 0.5)'
	ctx.globalCompositeOperation = 'xor'
	ctx.moveTo(points[0][0] / ratio, points[0][1] / ratio)
	for (var i = 0; i < points.length; i++) {
		ctx.lineTo(points[i][0] / ratio, points[i][1] / ratio)
	}
	ctx.fill()
	ctx.restore()
}

/**
 * 根据保存的操作记录在mask上画线
 * @param  object obj 操作记录对象
 */
ActionStack.prototype._renderTargetLine = function(obj) {
	let points = obj.points,
		ctxMask = this.ctxMask,
		ratio = obj.scale

	ctxMask.save()
	ctxMask.beginPath()
	ctxMask.lineCap = 'round';
	ctxMask.lineJoin = 'round';
	ctxMask.lineWidth = obj.lineWidth/ratio
	ctxMask.strokeStyle = (obj.globalCompositeOperation == 'xor') ? 'white' : 'black'
	ctxMask.moveTo(points[0][0] / ratio, points[0][1] / ratio)
	
	for (var i = 0; i < points.length; i++) {
		ctxMask.lineTo(points[i][0] / ratio, points[i][1] / ratio)
	}
	ctxMask.stroke()
	ctxMask.restore()
}

/**
 * 根据保存的操作记录在mask上画套索
 * @param  object obj 操作记录对象
 */
ActionStack.prototype._renderTargetLasso = function(obj) {
	let points = obj.points,
		ctxMask = this.ctxMask,
		ratio = obj.scale

	ctxMask.beginPath()
	ctxMask.save()
	ctxMask.lineWidth = 2/ratio
	ctxMask.strokeStyle = 'white'
	ctxMask.fillStyle = 'white'
	ctxMask.moveTo(points[0][0] / ratio, points[0][1] / ratio)
	for (var i = 0; i < points.length; i++) {
		ctxMask.lineTo(points[i][0] / ratio, points[i][1] / ratio)
	}
	ctxMask.stroke()
	ctxMask.closePath()
	ctxMask.fill()
	ctxMask.restore()
}

/**
 * 根据保存的操作记录在mask上画多边形
 * @param  object obj 操作记录对象
 */
ActionStack.prototype._renderTargetPolygon = function(obj) {
	let points = obj.points,
		ctxMask = this.ctxMask,
		ratio = obj.scale

	ctxMask.beginPath()
	ctxMask.save()
	ctxMask.lineWidth = 2/ratio
	ctxMask.fillStyle = 'white'
	ctxMask.moveTo(points[0][0] / ratio, points[0][1] / ratio)
	for (var i = 0; i < points.length; i++) {
		ctxMask.lineTo(points[i][0] / ratio, points[i][1] / ratio)
	}
	ctxMask.closePath()
	ctxMask.fill()
	ctxMask.restore()
}